import { FC } from 'react'
import { Likeable } from '@app/web-player/library/likeable.ts';

import { useAddItemsToLibrary } from '@app/web-player/library/requests/use-add-items-to-library.ts';
import { useRemoveItemsFromLibrary } from '@app/web-player/library/requests/use-remove-items-from-library.ts';

import { useLibraryStore } from '@app/web-player/library/state/likes-store.ts';
import { ContextMenuButton } from '@app/web-player/context-dialog/context-dialog-layout';

import { Trans } from '@ui/i18n/trans.tsx';
import { Tag } from '@common/tags/tag.ts';

import { useDialogContext } from '@ui/overlays/dialog/dialog-context.ts';
import { useAuthClickCapture } from '@app/web-player/use-auth-click-capture.ts';


export interface ContextFollowButtonProps {
    likeables: (Likeable | Tag)[]
    type: string
}

export const ContextFollowButton: FC<ContextFollowButtonProps> = ({ likeables, type }) => {
    const { close: closeMenu } = useDialogContext()
    const authHandler = useAuthClickCapture()

    const addToLibrary = useAddItemsToLibrary()
    const removeFromLibrary = useRemoveItemsFromLibrary()

    // @ts-ignore
    const isLiked = useLibraryStore(s => s.has(likeables))
    const isLoading = addToLibrary.isPending || removeFromLibrary.isPending

    const toggleLike = () => {
        if (isLiked) {
            // @ts-ignore
            removeFromLibrary.mutate({ likeables })
        } else {
            // @ts-ignore
            addToLibrary.mutate({likeables})
        }
    }

    return (
        <ContextMenuButton
            onClickCapture={authHandler}
            onClick={() => {
                closeMenu()
                toggleLike()
            }}
            disabled={isLoading}
        >
            {isLiked ? <Trans message={`Unfollow ${type}(s)`} /> : <Trans message={`Follow ${type}(s)`} />}
        </ContextMenuButton>
    )
}
